module.exports = __webpack_public_path__ + "static/media/paymentpage-bg.7988c59a.png";